export default __webpack_public_path__ + "static/media/footer_logo_jop@2x.3f0d1eb2.png";